/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Delete_Msg_ResultsInputs */



/**
* | output |
* | --- |
* | "This event has rounds and results. Deleting it removes them all, for good." |
*
* @param {Tournament_Delete_Msg_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_delete_msg_results = /** @type {((inputs?: Tournament_Delete_Msg_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Delete_Msg_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce tournoi a des rondes et des résultats. Le supprimer les efface tous, définitivement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este torneo tiene rondas y resultados. Borrarlo los elimina todos, para siempre.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este torneio tem rodadas e resultados. Excluí-lo apaga tudo, para sempre.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo torneo ha round e risultati. Eliminarlo li cancella tutti, per sempre.")
	return /** @type {LocalizedString} */ ("This event has rounds and results. Deleting it removes them all, for good.")
});